import React from 'react';
import { Link } from 'react-router-dom';
import { COMPANY, addressOneLine } from '../data/company';

const Privacy = () => {
  return (
    <div className="pt-24 pb-20 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 legal-content">
      <h1>Privacy Policy</h1>
      <p className="text-sm border-l-2 border-accent-red pl-4 mb-8">
        Last Updated: September 2026
      </p>

      <p>
        At {COMPANY.tradingName} we believe your data is your own. This policy explains what that
        means across everything we publish — and, just as importantly, where the one exception is.
      </p>

      <h2>1. Who is responsible for your data</h2>
      <p>
        The data controller is <strong>{COMPANY.legalName}</strong>, a company registered in
        {' '}{COMPANY.jurisdiction} under company number <strong>{COMPANY.number}</strong>, registered
        office {addressOneLine}. {COMPANY.tradingName} is a trading name of that company.
      </p>

      <h2>2. Two kinds of product, two different answers</h2>
      <p>
        <strong>Almost everything we publish</strong> — Chrono Arena, Eldritch Descent, PressVerse,
        TVVerse, RadioVerse and the Smart Memory Saver extension — does not collect, store or transmit
        any personal data. None of them needs an account and none of them phones home. Smart Memory
        Saver goes further and blocks its own network access in the manifest.
      </p>
      <p>
        <strong>PromptWick is the one exception.</strong> The rewrite it performs
        happens on a server, so the prompt you choose to improve does leave your browser, and an
        optional account keeps your library in sync. It has its own policy, and where the two differ,
        that one governs PromptWick:{' '}
        <Link to="/privacy/promptwick">the PromptWick Privacy Policy</Link>.
      </p>

      <h2>3. Desktop applications: no analytics, no telemetry</h2>
      <p>
        Our desktop applications do not include analytics trackers, telemetry modules or hidden crash
        reporting tools. We do not track what you watch, listen to or write.
      </p>

      <h2>4. Desktop applications: local storage only</h2>
      <p>
        All data generated by our desktop applications remains exclusively on your device. This
        includes your preferences, history and project files.
      </p>

      <h2>5. Your rights</h2>
      <p>
        Where we do hold personal data — which in practice means PromptWick accounts — UK GDPR gives
        you the right to access it, correct it, have it deleted, object to how it is used, and receive
        a copy in a portable form. You can delete a PromptWick account and its stored prompts from the
        extension's own settings, or write to us and we will do it.
      </p>
      <p>
        If you are unhappy with how we have handled your data you can complain to the Information
        Commissioner's Office at ico.org.uk.
      </p>

      <h2>6. Specific product policies</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
        <Link to="/privacy/promptwick" className="p-4 bg-card border border-border rounded-lg hover:border-accent-amber transition-colors text-center font-medium">
          PromptWick Policy
        </Link>
        <Link to="/privacy/smart-memory-saver" className="p-4 bg-card border border-border rounded-lg hover:border-signal transition-colors text-center font-medium">
          Smart Memory Saver Policy
        </Link>
        <Link to="/privacy/chrono-arena" className="p-4 bg-card border border-border rounded-lg hover:border-accent-orange transition-colors text-center font-medium">
          Chrono Arena Policy
        </Link>
        <Link to="/privacy/eldritch-descent" className="p-4 bg-card border border-border rounded-lg hover:border-accent-purple transition-colors text-center font-medium">
          Eldritch Descent Policy
        </Link>
        <Link to="/privacy/iron-fury" className="p-4 bg-card border border-border rounded-lg hover:border-accent-red transition-colors text-center font-medium">
          IRON FURY Policy
        </Link>
        <a href="https://matchdayempire.com/en/privacy/" target="_blank" rel="noopener noreferrer" className="p-4 bg-card border border-border rounded-lg hover:border-accent-emerald transition-colors text-center font-medium">
          MATCHDAY EMPIRE Policy
        </a>
        <Link to="/privacy/pressverse" className="p-4 bg-card border border-border rounded-lg hover:border-accent-emerald transition-colors text-center font-medium">
          PressVerse Policy
        </Link>
        <Link to="/privacy/tvverse" className="p-4 bg-card border border-border rounded-lg hover:border-accent-red transition-colors text-center font-medium">
          TVVerse Policy
        </Link>
        <Link to="/privacy/radioverse" className="p-4 bg-card border border-border rounded-lg hover:border-accent-blue transition-colors text-center font-medium">
          RadioVerse Policy
        </Link>
      </div>

      <h2 className="mt-12">7. Contact Us</h2>
      <p>
        If you have any questions about this Privacy Policy, please contact us at:{' '}
        <a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a>, or write to us at the registered
        office above.
      </p>
    </div>
  );
};

export default Privacy;
